export default __webpack_public_path__ + "static/media/5640036d-d549-4f16-b31e-87da78d9e832.fde6aa5b.eot";